import React from 'react';
import './IconButton.css';

export function IconButton({
  icon: Icon,
  size = 'md',
  variant = 'ghost',
  className = '',
  'aria-label': ariaLabel,
  ...props
}) {
  const iconSize = size === 'sm' ? 14 : size === 'lg' ? 20 : 16;

  return (
    <button
      className={`ui-icon-btn ui-icon-btn--${size} ui-icon-btn--${variant} ${className}`}
      aria-label={ariaLabel}
      {...props}
    >
      <Icon size={iconSize} />
    </button>
  );
}
